'use client';

import { SWRConfig } from 'swr';
import { ReactNode } from 'react';
import { fetcher } from './fetcher';

interface SWRProviderProps {
  children: ReactNode;
}

// Глобальный провайдер SWR с настройками по умолчанию
export function SWRProvider({ children }: SWRProviderProps) {
  return (
    <SWRConfig
      value={{
        fetcher,
        // Ревалидация при возврате фокуса на вкладку
        revalidateOnFocus: true,
        // Ревалидация при восстановлении сети
        revalidateOnReconnect: true,
        // Дедупликация запросов в течение 2 секунд
        dedupingInterval: 2000,
        // Троттлинг ревалидации при фокусе — 10 секунд
        focusThrottleInterval: 10000,
        // Сохраняем предыдущие данные при смене ключа
        keepPreviousData: true,
        // Повторные попытки при ошибках
        shouldRetryOnError: true,
        errorRetryCount: 3,
        errorRetryInterval: 5000,
        // Обработка ошибок глобально
        onError: (error, key) => {
          // Игнорируем 401/403 — обрабатываются отдельно
          if (error?.status === 401 || error?.status === 403) {
            return;
          }
          console.error(`SWR Error [${key}]:`, error);
        },
      }}
    >
      {children}
    </SWRConfig>
  );
}
